'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileUploads = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFileUploads = exports.getFileUploads = (0, _get2.default)('fileUploads');


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/selectors/getFileUploads.js
// module id = 663
// module chunks = 2 3